// extracted by mini-css-extract-plugin
export default {"section2":"section2_section2__nIpQC","content_box":"section2_content_box__qm7W7","title4":"section2_title4__SUB7D","hero_title2":"section2_hero_title2__vA9Ob"};